import { render, staticRenderFns } from "./TopCommunities.vue?vue&type=template&id=60dda636&scoped=true"
import script from "./TopCommunities.vue?vue&type=script&lang=js"
export * from "./TopCommunities.vue?vue&type=script&lang=js"
import style0 from "./TopCommunities.vue?vue&type=style&index=0&id=60dda636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dda636",
  null
  
)

export default component.exports